<template>
    <div class="flex flex-col mt-5">
        <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
            <div
                class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
            >
                <table class="min-w-full divide-y divide-gray-200">
                    <thead>
                        <tr>
                            <th
                                class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                            >
                                {{ $tc('messages.gamification_items', 1) }}
                            </th>
                            <th
                                class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                            >
                                {{ $t('messages.probability') }}
                            </th>
                            <th
                                class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                            >
                                {{ $t('messages.is_always_given') }}
                            </th>
                            <th
                                class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                            >
                                <span class="sr-only">{{ $t('messages.actions') }}</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="bg-white" v-for="(chestItem, index) in form" :key="index">
                            <td
                                class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                            >
                                <FormSelect
                                    required
                                    v-model.number="chestItem.gamification_item_id"
                                    :options="gamificationItems"
                                    class="mt-1 w-full"
                                />
                            </td>
                            <td class="max-w-sm truncate px-6 py-4 text-sm leading-5 font-medium text-gray-900">
                                <FormInput
                                    required
                                    v-model.number="chestItem.probability_to_obtain"
                                    :class="{
                                        invisible: chestItem.is_always_given,
                                    }"
                                    :name="`chestItems[${index}][probability_to_obtain]`"
                                    type="number"
                                    step="1"
                                    min="1"
                                    max="100"
                                    class="mt-1 w-full"
                                />
                            </td>
                            <td class="max-w-sm truncate px-6 py-4 text-sm leading-5 font-medium text-gray-900">
                                <input
                                    type="checkbox"
                                    v-model="chestItem.is_always_given"
                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                />
                            </td>
                            <td
                                class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                            >
                                <button
                                    type="button"
                                    @click="deleteRow(index)"
                                    class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                    <svg viewBox="0 0 20 20" fill="currentColor" class="trash w-4 h-4">
                                        <path
                                            fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"
                                        ></path>
                                    </svg>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="mt-3">
                <PlusButton @click="addRow()" />
            </div>
        </div>
    </div>
</template>

<script>
import PlusButton from '@/components/Forms/PlusButton.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormInput from '@/components/Forms/FormInput.vue';

export default {
    emits: ['update:modelValue'],

    components: {
        FormSelect,
        FormInput,
        PlusButton,
    },

    props: {
        modelValue: {
            required: true,
            type: Array,
        },
        type: {
            required: true,
            type: String,
        },
        gamificationItems: {
            required: true,
            type: Array,
        },
        errors: {
            required: false,
            type: Object,
        },
    },
    name: 'ChestItemsTable',
    data() {
        return {
            form: this.modelValue,
        };
    },
    methods: {
        addRow() {
            this.form.push({
                type: this.type,
                gamification_item_id: null,
                probability_to_obtain: 5,
                is_always_given: false,
            });
        },
        deleteRow(index) {
            this.form.splice(index, 1);
        },
    },

    watch: {
        form(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
};
</script>
